<ngx-spinner color="#cd0005"></ngx-spinner>

<!-- Settings View -->
<div
  *ngIf="loaded"
  id="settings-view"
  class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-[1024px]"
>
  <div class="mb-8">
    <h1 class="text-3xl font-semibold text-gray-900">Settings</h1>
  </div>
  <div class="bg-white rounded-lg shadow">
    <div class="border-b border-gray-200">
      <nav class="flex flex-wrap -mb-px">
        <ng-container *ngFor="let tab of tabs">
          <button
            class="border-b-2 whitespace-nowrap py-2 px-4 text-[1.1rem] font-medium flex items-center"
            [ngClass]="{
              'border-primary text-primary': activeTab === tab.key,
              'border-transparent text-gray-500 hover:text-gray-700': activeTab !== tab.key,
            }"
            (click)="setTab(tab.key)"
          >
            <i [class]="tab.icon + ' mr-2'"></i>
            {{ tab.label }}
          </button>
        </ng-container>
      </nav>
    </div>
    <div class="p-4 md:p-8 min-h-[600px]">
      <div *ngIf="activeTab === 'agency-info'" id="agency-info-panel">
        <div class="max-w-3xl">
          <form class="space-y-6" [formGroup]="accountForm">
            <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <label class="block text-[1.1rem] font-bold text-gray-700">
                  Company Name
                  <span class="text-primary">*</span>
                </label>
                <input
                  type="text"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. AirGateway GmbH"
                  formControlName="company_name"
                  error
                />
              </div>
              <div>
                <label class="block text-[1.1rem] font-bold text-gray-700">
                  Phone Number
                  <span class="text-primary">*</span>
                </label>
                <input
                  type="tel"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. +491570000000"
                  formControlName="phone_contact"
                  error
                />
              </div>
              <div>
                <label class="block text-[1.1rem] font-bold text-gray-700">
                  Email Contact
                  <span class="text-primary">*</span>
                </label>
                <input
                  type="email"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. no-reply@airgateway.com"
                  formControlName="email_contact"
                  error
                />
              </div>
              <div>
                <label
                  class="w-fit block text-[1.1rem] font-bold text-gray-700 tooltip"
                  [attr.data-tip]="
                    'This email address is used for alerts sent to the agency by the airline.'
                  "
                >
                  Operational Email
                  <i class="ri-information-line"></i>
                </label>
                <input
                  type="email"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. no-reply@airgateway.com"
                  formControlName="operational_email"
                  error
                />
              </div>
              <div>
                <label class="block text-[1.1rem] font-bold text-gray-700">
                  Agency Address
                  <span class="text-primary">*</span>
                </label>
                <input
                  type="tel"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. Gutzkowstr. 8"
                  formControlName="address"
                  error
                />
              </div>
              <div>
                <label class="block text-[1.1rem] font-bold text-gray-700">
                  Zip Code
                  <span class="text-primary">*</span>
                </label>
                <input
                  type="tel"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. 10827"
                  formControlName="postal_code"
                  error
                />
              </div>
              <div>
                <label class="block text-[1.1rem] font-bold text-gray-700">City Name</label>
                <input
                  type="tel"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. Berlin"
                  formControlName="city_name"
                  error
                />
              </div>
              <div>
                <label class="block text-[1.1rem] font-bold text-gray-700">State Prov</label>
                <input
                  type="tel"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                  placeholder="e.g. Berlin"
                  formControlName="state_prov"
                  error
                />
              </div>
            </div>
            <div class="flex justify-end">
              <button (click)="saveChanges()" type="submit" class="btn btn-primary text-base">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngIf="activeTab === 'branding'" id="branding-panel">
        <div class="max-w-3xl">
          <div class="space-y-8">
            <div>
              <label class="block text-sm font-medium text-gray-700">Agency Logo</label>
              <div class="mt-1 flex items-center space-x-6">
                <div
                  class="h-32 w-32 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden"
                >
                  <img
                    *ngIf="imageURL; else placeholder"
                    [src]="imageURL"
                    class="object-contain h-full w-full"
                  />
                  <ng-template #placeholder>
                    <i class="ri-image-line text-4xl text-gray-400"></i>
                  </ng-template>
                </div>

                <div class="flex flex-col gap-3">
                  <button
                    [attr.data-tip]="
                      'Max height: 200px\nMax width: 200px\nAllowed extensions: png, jpg, jpeg'
                    "
                    type="button"
                    (click)="fileInput.click()"
                    class="btn tooltip"
                  >
                    Upload New Logo
                  </button>
                  <button
                    *ngIf="imageURL"
                    type="button"
                    (click)="removeLogo()"
                    class="btn btn-neutral"
                  >
                    Remove Current Logo
                  </button>
                  <input
                    #fileInput
                    type="file"
                    accept="image/*"
                    hidden
                    (change)="onLogoSelected($event)"
                  />
                </div>
              </div>

              <div *ngIf="imageError" class="text-red-600 text-sm mt-2">
                {{ imageError }}
              </div>
            </div>
            <div>
              <form [formGroup]="accountForm">
                <label class="block text-sm font-medium text-gray-700">Brand Colors</label>
                <div class="mt-4 grid grid-cols-2 gap-4">
                  <div>
                    <label class="block text-xs text-gray-500 mb-1">Primary Color</label>
                    <input
                      type="color"
                      class="h-10 w-full rounded-md border-gray-300"
                      formControlName="brand_color"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div class="flex justify-end md:justify-center mt-auto pt-8">
              <button (click)="saveChanges()" type="button" class="btn btn-md btn-primary">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="activeTab === 'notifications'" id="notifications-panel">
        <div class="max-w-3xl">
          <div class="space-y-6">
            <div class="bg-gray-50 rounded-lg p-4">
              <h3 class="text-2xl font-medium text-gray-900">Email Notifications</h3>
              <div class="mt-4 space-y-4">
                <div
                  *ngFor="let notification of notificationSettings"
                  class="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0"
                >
                  <div>
                    <h4 class="md:text-xl font-medium text-gray-700">
                      {{ notification.title }}
                    </h4>
                  </div>
                  <label
                    class="relative inline-flex items-center cursor-pointer self-start md:self-auto"
                  >
                    <input
                      type="checkbox"
                      class="sr-only peer"
                      [checked]="notification.enabled"
                      (change)="toggleNotificationSettings(notification)"
                    />
                    <div
                      class="w-16 h-9 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-8 after:w-8 after:transition-all peer-checked:bg-primary"
                    ></div>
                  </label>
                </div>
              </div>
            </div>

            <div class="flex items-start gap-2">
              <i class="ri-info-card-line ri-xl pt-[6px]"></i>
              <span class="text-gray-700">
                These notifications are sent to the agent who created the order. Turning off these
                notifications will disable them agency-wide for all agents.
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--      <div *ngIf="activeTab === 'rules'" id="rules-panel">-->
      <!--        <div class="max-w-4xl">-->
      <!--          <div class="space-y-8">-->
      <!--            <app-rule-list></app-rule-list>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</div>
